import useControllers from "../../../../controllers";
import useComponents from "../../../components";

const View = () => {
  const {
    ContentWrappers,
    Typography,
    useButtons,
    SelectFieldControlled,
  } = useComponents();

  const { DefaultButton } = useButtons();

  const { useScreenHooks } = useControllers();
  const { usePaymentsScreen } = useScreenHooks();
  const { paymentsRoot } = usePaymentsScreen();
  const { handleSubmit, onSubmit, control, listCountries, rol } = paymentsRoot();

  return (
    <div className="flex w-full h-screen-60 items-center">
      <ContentWrappers gridColums={["1fr"]} className="max-w-screen-md w-11/12" as="section">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="bg-white px-8 pt-10 pb-10 rounded-lg items-center flex flex-col">
            <Typography variant="h3" className="uppercase text-left w-full pb-6">
              1. Listado de pagos por país
            </Typography>
            <SelectFieldControlled
              name="country_id"
              id="abi-country_id"
              control={control}
              label="País"
              options={[
                ...listCountries,
                // Only show Multizonal for Súper Administrador
                ...(rol === "Súper Administrador" ? [{ value: "multizonal", label: "Multizonal" }] : []),
              ]}
            />
            <div className="mt-7">
              <DefaultButton color="secondary" type="submit">
                Cargar listado
              </DefaultButton>
            </div>
          </div>
        </form>
      </ContentWrappers>
    </div>
  );
};

export default View;
